import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import MenuItem from '../MenuItem/MenuItem';
import Modal from '../../Modal/Modal';
import LanguageList from './LanguageList';
import { InitializeLanguageList, CloseLanguageModal } from '../../../actions/profileMenuAction';

export const LanguageIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5449 7.8348C15.6554 7.8382 15.7332 7.9466 15.7066 8.05388L15.693 8.10961C15.6874 8.13271 15.6819 8.15527 15.6764 8.17724C15.6549 8.28247 15.6338 8.398 15.6137 8.52127C16.3091 8.49385 16.9334 8.42866 17.5555 8.29382C17.6603 8.27108 17.761 8.3495 17.7619 8.45679L17.7652 8.83501C17.7659 8.91606 17.7085 8.98596 17.6285 8.99924C17.0282 9.09898 16.2468 9.17063 15.5217 9.20522C15.5016 9.39166 15.4846 9.58391 15.4721 9.7762C15.7792 9.70596 16.1077 9.66558 16.4174 9.66558C16.4565 9.66558 16.4952 9.66632 16.5336 9.6678C16.5462 9.60794 16.5576 9.54283 16.5668 9.48056C16.5822 9.37676 16.6832 9.30238 16.7852 9.32724L17.1736 9.42196C17.2745 9.44659 17.3309 9.55764 17.2963 9.65564C17.2808 9.69962 17.2649 9.74607 17.2495 9.7914C17.9889 10.0321 18.4757 10.6002 18.4757 11.3376C18.4757 12.2157 17.9686 13.0636 16.5004 13.3271C16.435 13.3389 16.3691 13.3089 16.3337 13.2528L16.1105 12.8997C16.0446 12.7955 16.1113 12.6578 16.2325 12.6357C17.2628 12.448 17.6904 11.8792 17.6904 11.2996C17.6904 10.9216 17.4625 10.5843 17.0309 10.4168C16.6879 11.2729 16.1847 11.9357 15.6978 12.3399C15.7268 12.4459 15.7574 12.549 15.7889 12.65C15.8168 12.7396 15.7667 12.8352 15.6766 12.8619L15.2672 12.9829C15.181 13.0084 15.0901 12.9612 15.0644 12.8751C15.0543 12.8412 15.0443 12.8064 15.0343 12.7706C14.7275 12.9228 14.3881 13.0286 14.0487 13.0286C13.5864 13.0286 13.2001 12.7499 13.2001 12.1039C13.2001 11.2864 13.8689 10.4369 14.7547 10.0174C14.7682 9.75086 14.7894 9.48339 14.8133 9.22726C14.7448 9.22813 14.6777 9.22858 14.6124 9.22858C14.3694 9.22858 14.0435 9.21199 13.7691 9.19802L13.6405 9.19152C13.553 9.18718 13.4833 9.11627 13.481 9.02869L13.4712 8.65238C13.4685 8.54949 13.5588 8.46834 13.6611 8.47913C13.9314 8.50764 14.3311 8.53824 14.6314 8.53824C14.7172 8.53824 14.8018 8.53795 14.8852 8.53733L14.9227 8.20258C14.9293 8.13708 14.9358 8.06649 14.9398 7.99784C14.9453 7.90028 15.0257 7.81883 15.1233 7.82183L15.5449 7.8348ZM13.9474 11.9392C13.9474 11.5829 14.2646 11.0969 14.7414 10.7741C14.7525 11.215 14.8022 11.6519 14.8718 12.0449C14.639 12.1815 14.4163 12.2559 14.2387 12.2559C14.0297 12.2559 13.9474 12.1482 13.9474 11.9392ZM15.4484 10.4636C15.4484 10.8542 15.4764 11.2005 15.523 11.5155C15.8279 11.2032 16.1098 10.8174 16.3241 10.3056C15.9884 10.3111 15.6948 10.3719 15.4484 10.4491L15.4484 10.4636Z"
      fill="#032185"
    />
    <path
      d="M10.1925 13.3452C10.1545 13.3452 10.1228 13.3304 10.0975 13.3009C10.0721 13.2755 10.0595 13.246 10.0595 13.2122C10.0595 13.1911 10.0637 13.17 10.0721 13.1489L12.2255 7.98088C12.2381 7.9471 12.2593 7.91544 12.2888 7.88588C12.3226 7.8521 12.3711 7.83521 12.4345 7.83521H12.9221C12.9601 7.83521 12.9918 7.84999 13.0171 7.87955C13.0425 7.90488 13.0551 7.93444 13.0551 7.96821C13.0551 7.9851 13.0509 8.00621 13.0425 8.03155L10.8828 13.1995C10.8701 13.2291 10.8469 13.2608 10.8131 13.2945C10.7836 13.3283 10.735 13.3452 10.6675 13.3452H10.1925Z"
      fill="#032185"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.65717 12.8132C5.61917 12.8132 5.5875 12.8005 5.56217 12.7752C5.53684 12.7457 5.52417 12.714 5.52417 12.6802C5.52417 12.6591 5.52628 12.6401 5.5305 12.6232L7.03784 8.55088C7.0505 8.50444 7.07584 8.46433 7.11384 8.43055C7.15184 8.39677 7.20461 8.37988 7.27217 8.37988H8.08284C8.15039 8.37988 8.20317 8.39677 8.24117 8.43055C8.27917 8.46433 8.3045 8.50444 8.31717 8.55088L9.8245 12.6232C9.82873 12.6401 9.83084 12.6591 9.83084 12.6802C9.83084 12.714 9.81817 12.7457 9.79284 12.7752C9.7675 12.8005 9.73584 12.8132 9.69784 12.8132H9.03917C8.97584 12.8132 8.92939 12.7984 8.89984 12.7689C8.87028 12.7393 8.85128 12.7119 8.84284 12.6865L8.5705 11.9772H6.7845L6.51217 12.6865C6.50373 12.7119 6.48473 12.7393 6.45517 12.7689C6.42561 12.7984 6.37917 12.8132 6.31584 12.8132H5.65717ZM7.01884 11.1602H8.32984L7.6775 9.33621L7.01884 11.1602Z"
      fill="#032185"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3333 4.6001H4.66667C3.74619 4.6001 3 5.34629 3 6.26676V14.7427C3 15.6632 3.74619 16.4094 4.66667 16.4094H11V18.3521C11 18.5544 11.0604 18.833 11.2826 19.0692C11.4925 19.2923 11.741 19.3642 11.892 19.3873C12.1551 19.4275 12.38 19.3606 12.4553 19.3378C12.6609 19.2757 12.8863 19.1654 13.0793 19.0632C13.4909 18.8451 14.0257 18.5159 14.5616 18.171C15.577 17.5175 16.6837 16.7512 17.173 16.4094H19.3333C20.2538 16.4094 21 15.6632 21 14.7427V6.26676C21 5.34629 20.2538 4.6001 19.3333 4.6001ZM11.3333 15.4094C11.7015 15.4094 12 15.7073 12 16.0755V18.3521C12 18.4192 12.0907 18.4129 12.2474 18.3521C12.4123 18.2882 12.6502 18.1639 12.9322 18.001C12.9545 17.9881 12.9771 17.975 13 17.9616C14.1958 17.2628 16.1087 15.934 16.6865 15.5293C16.7994 15.4502 16.9311 15.4094 17.069 15.4094H19.3333C19.7015 15.4094 20 15.1109 20 14.7427V6.26676C20 5.89857 19.7015 5.6001 19.3333 5.6001H4.66667C4.29848 5.6001 4 5.89857 4 6.26676V14.7427C4 15.1109 4.29848 15.4094 4.66667 15.4094H11.3333Z"
      fill="#032185"
    />
  </svg>
);

const Language = ({ intl, menuDetails }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    dispatch(InitializeLanguageList());
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
    dispatch(CloseLanguageModal());
  };

  return (
    <>
      <MenuItem
        label={intl.formatMessage({
          id: `gen2.profileMenu.label.${menuDetails.id}`,
        })}
        icon={<LanguageIcon />}
        handleClick={handleClickOpen}
      />
      <Modal open={open} handleClose={handleClickClose}>
        <LanguageList onClose={handleClickClose} />
      </Modal>
    </>
  );
};

Language.propTypes = {
  menuDetails: PropTypes.shape({
    id: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
  intl: PropTypes.arrayOf(
    PropTypes.shape({
      locale: PropTypes.string.isRequired,
      formatMessage: PropTypes.func.isRequired,
    }),
  ).isRequired,
};

export default injectIntl(Language);
